import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';

import './PreviewError.scss';

function PreviewError({ fileName, t }) {
  return <div className="PreviewError">{t('could_not_display_file', { file: fileName })}</div>;
}

export default withTranslation()(memo(PreviewError));
